import { gateway } from "../../../gateway";

export const deleteVendor = async (token: string | null, id: string) => {
  try {
    const res = await gateway.delete(`/vendors?uids=${id}`, {
      headers: {
        Authorization: `${token}`,
      },
    });
    return res.data || res.data?.data;
  } catch (error) {
    throw error;
  }
};
